import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { breadcrumb, link } from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-ms-factor-dashboard',
  templateUrl: './ms-factor-dashboard.component.html',
  styleUrls: ['./ms-factor-dashboard.component.scss', '../../../../mystery-shopper/mystery-shopper.component.scss']
})
export class MsFactorDashboardComponent {


  //Constants
  header: string = this.translate("Dashboard");
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-arrow-left',
      link: '/ms/project',
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
  ];
  factorStatusConstants = [
    { status: 'Pending', count: 0 },
    { status: 'On-Hold', count: 0 },
    { status: 'In-Progress', count: 0 },
    { status: 'Challenge', count: 0 },
    { status: 'Done', count: 0 }
  ];
  //Data variables
  projectId: string = '';
  factors: any[] = [];
  filteredData: any[] = [];

  //Toogle variabels
  currentStatus: string = this.factorStatusConstants[0].status;
  skelition: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router
  ) { }

  ngOnInit() {
    this.currentStatus = this.factorStatusConstants[0].status;
    this.route.params.subscribe(params => {
      this.projectId = params['projectId'];
      if (this.projectId) {
        this.breadcrumbs.push({ name: this.translate('Dashboard'), link: `/ms/factor-dashboard/${this.projectId}` },)
        this.links.push({
          name: this.translate('Forwarding'),
          icon: 'pi pi-arrow-right-arrow-left', link: `/ms/factor-forward/${this.projectId}`
        })
        this.getDashboardData();
        this.route.queryParams.subscribe(qParams => {
          let status = qParams['status'];
          if (!status) {
            this.changeCurrentStatus(this.currentStatus);
          } else {
            this.currentStatus = status;
            this.filteredData = this.factors.filter(f => f.status == this.currentStatus);
          }
        })
      } else {
        this.router.navigate(['/ms/project'])
      }
    })
  }

  async getDashboardData() {
    try {
      this.skelition = true;
      let res = await this.dataService.getData(`ms-factors/dashboard/${this.projectId}`)
      this.skelition = false;
      if (res.error) {
        console.log(res.error);
        return;
      }
      res.data.counts.forEach((e: any) => {
        let status = this.factorStatusConstants.find(f => f.status == e.title);
        if (status) {
          status.count = e.count;
        }
      })
      this.factors = res.data.data;
      this.filteredData = this.factors.filter(f => f.status == this.currentStatus)
      console.log(this.factors);
    } catch (e) {
      console.log(e);
    }
  }

  changeCurrentStatus(status: string) {
    const queryParams: Params = { status };
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams,
        queryParamsHandling: 'merge',
      }
    );

  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
}
